<script lang="ts">
  import type { ClassValue } from 'svelte/elements';

  interface Props {
    title: string;
    class?: ClassValue;
    error?: string[] | string | undefined;
    input: import('svelte').Snippet<[placeholder: string]>;
  }

  let { title, class: _class, input, error }: Props = $props();
</script>

<label class={['floating-label', _class]}>
  {@render input(title)}
  <span>{title}</span>
  {#if error}
    <div class="text-error mt-1 px-1 text-xs">{error}</div>
  {/if}
</label>
